export function getFileNameFromUrl(
    url: string
)
{
    return url.split('/').pop();
}